import { getApiClient } from './ApiClient'

export const retrieveSubscriptionStatusPromise = (params) => {
  return getApiClient().get('/subscription-status', { params })
}
